module.exports = {
    customer: 'motolino',
    assets: { logo: 'logo.svg' }
    
};